export class SchoolsList {
    panelID: string;
    panelTrigger: HTMLButtonElement;
    isShowing: boolean;
    toggledItems: HTMLElement[];
    indicator: HTMLElement;
    indicatorAmt: string;
    totalCount: string;

    constructor(panel: HTMLUListElement) {
        this.panelID = panel.id;
        this.panelTrigger = document.querySelector(`[aria-controls="${this.panelID}"]`);
        if (this.panelTrigger) {
            this.isShowing = false;
            this.panelTrigger.addEventListener('click', this.toggleItems.bind(this));
            this.toggledItems = [].slice.call(panel.querySelectorAll('[aria-hidden="true"]')) as HTMLElement[];
            this.indicator = document.querySelector(`[data-schools-count="${this.panelID}"]`) as HTMLElement;
            if (this.indicator) {
                this.indicatorAmt = this.indicator.innerHTML;
                this.totalCount = `${panel.querySelectorAll('li').length}`;
            }
        }
    }

    toggleItems() {
        if (this.isShowing) {
            // hide
            this.panelTrigger.setAttribute('aria-expanded', 'false');
            this.toggledItems.forEach(item => {
                item.setAttribute('aria-hidden', 'true');
            });
            if (this.indicator) {
                this.indicator.innerHTML = this.indicatorAmt;
            }
        }
        else {
            // show
            this.panelTrigger.setAttribute('aria-expanded', 'true');
            this.toggledItems.forEach(item => {
                item.setAttribute('aria-hidden', 'false');
            });
            if (this.indicator) {
                this.indicator.innerHTML = this.totalCount;
            }
        }
        this.isShowing = !this.isShowing;
    }
}